import {api} from './api';

export const mediaRecordingsApi = {
  searchMediaRecordingsByMeetingId: async (meetingId) => {
    return api.recorderSvcRequest('GET', `/mediaRecordings?meetingId=${meetingId}`);
  }
};